export function supplierRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SUPPLIER_START":           
        case "FETCH_SUPPLIERS_START":                                 
        case "UPDATE_SUPPLIER_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SUPPLIER_FULFILLED":           
        case "FETCH_SUPPLIERS_FULFILLED":                                 
        case "UPDATE_SUPPLIER_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SUPPLIER_ERROR":
        case "FETCH_SUPPLIERS_ERROR":
        case "UPDATE_SUPPLIER_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}